import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UntypedFormArray } from '@angular/forms';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import {
  investmentsForbidenOptions,
  nonESGInvestmentsOptions,
} from '@app/forms/subscription/services/ref';

@Component({
    selector: 'esg-investment-situation',
    templateUrl: './esg-investment-situation.component.html',
    styleUrls: ['./esg-investment-situation.component.scss'],
    standalone: false
})
export class EsgInvestmentSituationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  nonESGInvestmentsOptions = nonESGInvestmentsOptions;
  investmentsForbidenOptions = investmentsForbidenOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  subscribeToEsgProfileChanges() {
    this.owners?.controls.forEach(control => {
      const esgProfile = control.get('esgProfil');
      const result = esgProfile?.get('includeNonESG')?.value;
      if (!result) {
        esgProfile?.get('nonESGInvestments').setValue(null);
        // esgProfile?.get("investmentsForbiden").setValue(null);
      }
    });
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  onSubmit() {
    this.subscribeToEsgProfileChanges();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
